import { gql } from '@apollo/client'

export const JOB_DETAIL_GENERAL_FRAGMENT = gql`
	fragment jobDetailGeneralFragment on JobGeneral {
		disciplines {
			disciplineName
			id
			disciplineType
		}
		jobGeneralSpecialties {
			id
			specialtyId
			disciplineId
			perDiemPayRate
			perDiemPayRateType
		}
		address {
			id
			country
			state
			city
			latitude
			zipcode
			longitude
		}
		benefitsText
		certificationsRequired
		customFields
		description
		externalId
		facility {
			id
			name
			facilityTypes
			address {
				id
				country
				state
				city
				latitude
				zipcode
				longitude
			}
		}
		hotJob
		id
		isPerDiem
		licenseStateCompact
		licenseStateRequired
		payCurrency
		requirementsText
		settings
		title
		workTypes
		specialties {
			discipline {
				id
				disciplineName
				disciplineType
				externalId
			}
			externalId
			id
			jobsCount
			longName
			name
		}
	}
`
export const JOB_DETAIL_FRAGMENT = gql`
	fragment jobDetailFragment on Job {
		benefitsText
		billRate
		customFields
		externalFriendlyId
		isPerDiemLongTerm
		isPublish
		duration
		durationType
		endDatetime
		externalId
		hoursPerDay
		hoursPerWeek
		timezone
		id
		isFavorited
		atsSource
		metadata
		jobGeneral {
			...jobDetailGeneralFragment
		}
		matchingPercentage
		payAmountMax
		payAmountMin
		publishedAt
		payRate
		payType
		requirementsText
		shifts
		slotsNumber
		startDatetime
		viewedCount
		status
		educationLevel
		minYearsOfExperience
		jobApplicant {
			status
		}
		workerAssignment {
			payRate
			payType
			id
			status
			payRate
			payType
			salary
		}
		canRequestInterview
	}
	${JOB_DETAIL_GENERAL_FRAGMENT}
`
